// Number of days to fetch events for in a paginated manner.
export const EVENT_PAGE_SIZE_BY_DAYS = {
    PrevPage: 14,
    NextPage: 14,
};
